import { useEffect, useState, useSyncExternalStore } from 'react';
import { Loader2 } from 'lucide-react';
import { retryState } from '@/lib/api';

/** How long a retry runs before the note shows; most blips are over sooner and need no note. */
export const RECONNECTING_AFTER_MS = 2_000;

/**
 * t269u: a quiet "Reconnecting…" line while the API client is retrying (a deploy restart, a dropped connection).
 * The button that started the request stays busy; this just says why it's taking a moment.
 */
export function ReconnectingNote() {
  const retrying = useSyncExternalStore(retryState.subscribe, retryState.get, () => false);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!retrying) { setShow(false); return; }
    const t = setTimeout(() => setShow(true), RECONNECTING_AFTER_MS);
    return () => clearTimeout(t);
  }, [retrying]);
  if (!show) return null;
  return (
    <div className="pointer-events-auto flex items-center gap-2 self-end rounded-full bg-white px-3 py-1.5 text-xs text-slate-600 shadow ring-1 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700" data-testid="reconnecting">
      <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden />Reconnecting…
    </div>
  );
}
